<!--
  REV-21372 — Uebersicht „Kommentare"/„Pendenzen" (ADR-0019 E7). EINE Komponente, zweimal montiert.

  ⚠️ Aufbau und Ton folgen dem AWF-Prototyp und dem NACHBAR-Register (Korrekturbuchungen): dieselbe
  Leiste (Pillen · Spacer · Anlegen · Exportieren), dieselbe Trefferzeile, dieselbe Tabelle. Die
  Tabelle traegt den gemeinsamen ABCP-Tabellenlook (`styles/_abcp-table.scss`), wie alle ABCP-Tabellen.

  SELEKTOR-CONTRACT — die Tests haengen HIER dran, nie an Klassen, Farben oder uebersetztem Text:

    [data-testid="notes-overview"]              Wurzel; [data-kind] = COMMENT | TODO
    [data-testid="notes-filter-pill"]           Pille (`ham-filter-pill`); [data-filter-key], [data-row], [data-active]
    [data-testid="filter-pill-count"]           Zahl IN der Pille
    [data-testid="notes-create"]                „Neue Pendenz" — NUR im Pendenzen-Register (AC11)
    [data-testid="notes-export"]                „Exportieren" (oeffnet das Menue)
    [data-testid="notes-export-menu"]           das Menue
    [data-testid="notes-export-note"]           „Exportiert die aktuelle Ansicht — N Positionen"
    [data-testid="notes-export-current"]        CSV — exportiert die aktuelle Ansicht
    [data-testid="notes-export-print"]          „Druckansicht" — bewusst deaktiviert (E8)
    [data-testid="notes-active-filter"]         aktiver Filter; [data-filter-key]
    [data-testid="notes-active-filter-remove"]  dessen ×
    [data-testid="notes-filters-reset"]         „Zuruecksetzen"
    [data-testid="notes-search-hits"]           Trefferzeile der Suche
    [data-testid="notes-search-reset"]          „Suche aufheben"
    [data-testid="notes-table"]                 Tabelle
    [data-testid="notes-column"]                Spaltenkopf; [data-column], [aria-sort]
    [data-testid="notes-row"]                   Zeile; [data-note-id], [data-source],
                                                [data-overdue], [data-done], [data-recent]
    [data-testid="notes-row-done"]              Erledigt-Kaestchen (nur TODO)
    [data-testid="notes-cell-<column>"]         Zelle
    [data-testid="notes-tag"]                   Marke in der Marken-Zelle
    [data-testid="notes-empty"]                 leer (nichts da)
    [data-testid="notes-no-match"]              nichts gefunden (etwas da, nur nicht das)
    [data-testid="notes-loading"]               laedt
    [data-testid="notes-error"]                 Fehler
    [data-testid="notes-retry"]                 erneut versuchen

  ⚠️ Praezedenz: loading > error > (empty | no-match) > filled.
-->
<div class="notes-ov" data-testid="notes-overview" [attr.data-kind]="kind">
    <!-- ── Leiste: Pillen · Spacer · Anlegen · Exportieren ──────────────────────────────────── -->
    <div class="notes-ov__bar">
        <!-- Kommentare: EINE Reihe. Immer alle drei, nie bei 0 versteckt. -->
        <div class="notes-ov__pills" *ngIf="!isTodo">
            <ham-filter-pill
                data-testid="notes-filter-pill"
                data-row="1"
                *ngFor="let key of commentFilters"
                [attr.data-filter-key]="key"
                [label]="commentFilterLabelKey(key) | i18next"
                [count]="commentCount(key)"
                [active]="key === commentFilter"
                (pillClick)="commentFilterChange.emit(key)"
            ></ham-filter-pill>
        </div>

        <!-- Pendenzen: ZWEI Reihen — erst Status, dann Zielgruppe (AC3). -->
        <ng-container *ngIf="isTodo">
            <div class="notes-ov__pills">
                <ham-filter-pill
                    data-testid="notes-filter-pill"
                    data-row="1"
                    *ngFor="let key of todoStatuses"
                    [attr.data-filter-key]="key"
                    [label]="todoStatusLabelKey(key) | i18next"
                    [count]="todoStatusCount(key)"
                    [active]="key === todoStatus"
                    (pillClick)="todoStatusChange.emit(key)"
                ></ham-filter-pill>
            </div>

            <div class="notes-ov__pills notes-ov__pills--second">
                <ham-filter-pill
                    data-testid="notes-filter-pill"
                    data-row="2"
                    *ngFor="let key of todoAudiences"
                    [attr.data-filter-key]="key"
                    [label]="todoAudienceLabelKey(key) | i18next"
                    [count]="todoAudienceCount(key)"
                    [active]="key === todoAudience"
                    (pillClick)="todoAudienceChange.emit(key)"
                ></ham-filter-pill>
            </div>
        </ng-container>


        <!--
            Reihenfolge und Form aus dem Prototyp abgelesen: Exportieren LINKS als sekundaerer
            Knopf (Symbol links, Pfeil rechts), danach der primaere Anlegen-Knopf. Die primaere
            Handlung schliesst die Reihe ab.
        -->
        <!-- Die beiden Bedienelemente bleiben ZUSAMMEN rechts, auch wenn die Pillen umbrechen.
             Vorher schob ein Spacer sie einzeln um, und bei zwei Pillen-Reihen landeten sie
             auf einer eigenen Zeile. -->
        <div class="notes-ov__actions">
        <div class="notes-ov__export">
            <ham-button
                data-testid="notes-export"
                variant="white"
                size="toolbar"
                icon="assets/hamIcons/arrow-down-to-bracket-outline.svg"
                rightIcon="assets/hamIcons/chevron-down.svg"
                (buttonClick)="toggleExportMenu()"
            >
                {{ 'aumico_abcp_notes_export' | i18next }}
            </ham-button>

            <ng-container *ngIf="exportMenuOpen">
                <!-- Ein Klick daneben schliesst das Menue. Ohne diese Flaeche bleibt es offen
                     stehen, bis man genau den Knopf wieder trifft. -->
                <div class="notes-ov__backdrop" (click)="toggleExportMenu()"></div>

                <div class="notes-ov__menu" data-testid="notes-export-menu">
                    <p class="notes-ov__menu-note" data-testid="notes-export-note">
                        {{ 'aumico_abcp_notes_export_current' | i18next }}
                        &mdash; {{ rows.length }}
                        {{ 'aumico_abcp_notes_export_positions' | i18next: { count: rows.length } }}
                    </p>

                    <div class="notes-ov__menu-actions">
                        <ham-button
                            class="notes-ov__menu-item"
                            data-testid="notes-export-current"
                            variant="white"
                            size="toolbar"
                            icon="assets/hamIcons/file-export-outline.svg"
                            (buttonClick)="onExport()"
                        >
                            CSV
                        </ham-button>
                        <!--
                            ⚠️ Sichtbar, aber DEAKTIVIERT. Der Prototyp hat hier einen
                            gleichwertigen Knopf; dieses Buendel baut die Druckansicht ausdruecklich
                            nicht (ADR-0019 E8). Weglassen wuerde den Unterschied zum Prototyp
                            verstecken, klickbar lassen etwas versprechen, das nicht kommt — der
                            Hinweistext sagt, warum er nicht geht.
                        -->
                        <ham-button
                            class="notes-ov__menu-item"
                            data-testid="notes-export-print"
                            variant="white"
                            size="toolbar"
                            lucideIcon="printer"
                            [disabled]="true"
                            [hamTooltip]="'aumico_abcp_notes_export_print_hint' | i18next"
                            tooltipClass="abcp"
                        >
                            {{ 'aumico_abcp_notes_export_print' | i18next }}
                        </ham-button>
                    </div>
                </div>
            </ng-container>
        </div>

        <!--
            ⚠️ Der Anlegen-Knopf NUR hier (AC11): eine Pendenz wird im Register erfasst, ein
            Kommentar entsteht am Konto. Beschriftung wie im Prototyp — nur „Pendenz", mit dem
            Plus LINKS davor.
        -->
        <ham-button
            data-testid="notes-create"
            variant="primary"
            size="toolbar"
            icon="assets/hamIcons/plus-outline.svg"
            *ngIf="mayCreate"
            (buttonClick)="createRequested.emit()"
        >
            {{ 'aumico_abcp_notes_new_todo' | i18next }}
        </ham-button>
        </div>
    </div>

    <!-- Was gerade gilt — einzeln abwerfbar (AC4). -->
    <div class="notes-ov__active" *ngIf="activeFilters.length > 0">
        <span
            class="notes-ov__chip"
            data-testid="notes-active-filter"
            *ngFor="let chip of activeFilters"
            [attr.data-filter-key]="chip.key"
        >
            {{ chip.label }}
            <button
                type="button"
                class="notes-ov__chip-x"
                data-testid="notes-active-filter-remove"
                [attr.aria-label]="'aumico_abcp_notes_filter_remove' | i18next"
                (click)="filterRemove.emit(chip.key)"
            >
                ✕
            </button>
        </span>

        <button type="button" class="notes-ov__link" data-testid="notes-filters-reset" (click)="filtersReset.emit()">
            {{ 'aumico_abcp_notes_filters_reset' | i18next }}
        </button>
    </div>

    <!-- Die Trefferzeile der Suche — eigene Zeile, wie beim Nachbar-Register (AC5). -->
    <p class="notes-ov__hits" data-testid="notes-search-hits" *ngIf="searchHits !== null">
        {{
            (isTodo ? 'aumico_abcp_notes_search_hits_todos' : 'aumico_abcp_notes_search_hits_comments')
                | i18next: { count: searchHits, term: searchTerm }
        }}
        <button type="button" class="notes-ov__link" data-testid="notes-search-reset" (click)="searchReset.emit()">
            {{ 'aumico_abcp_notes_search_reset' | i18next }}
        </button>
    </p>

    <!-- Ticking off shows no message: the row stays crossed out as long as `recentlyChangedId` names it. -->

    <!-- ── Tabelle ──────────────────────────────────────────────────────────────────────────── -->
    <div class="notes-ov__scroll">
        <table class="notes-ov__table" data-testid="notes-table">
            <thead>
                <tr>
                    <!-- Vorspalte: nur die Pendenz hat ein Erledigt-Kaestchen (ADR-0019 E7). -->
                    <th class="notes-ov__th notes-ov__th--check" scope="col" *ngIf="isTodo"></th>
                    <th
                        class="notes-ov__th"
                        data-testid="notes-column"
                        scope="col"
                        *ngFor="let column of columns"
                        [attr.data-column]="column"
                        [attr.aria-sort]="ariaSort(column)"
                    >
                        <abcp-sort-header [direction]="sortDirection(column)" (sortClick)="onSort(column)">
                            {{ columnLabelKey(column) | i18next }}
                        </abcp-sort-header>
                    </th>
                </tr>
            </thead>

            <tbody>
                <!-- Laedt: Platzhalter in der FORM der Liste, damit die Hoehe nicht springt. -->
                <tr *ngIf="showSkeleton">
                    <td class="notes-ov__state-cell" [attr.colspan]="isTodo ? columns.length + 1 : columns.length">
                        <div class="notes-ov__loading" data-testid="notes-loading">
                            <div class="notes-ov__skeleton" *ngFor="let row of skeletonRows"></div>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loading && error">
                    <td class="notes-ov__state-cell" [attr.colspan]="isTodo ? columns.length + 1 : columns.length">
                        <div class="notes-ov__state notes-ov__state--error" data-testid="notes-error">
                            <p>{{ 'aumico_abcp_notes_overview_error' | i18next }}</p>
                            <ham-button
                                data-testid="notes-retry"
                                variant="white"
                                size="toolbar"
                                (buttonClick)="retryRequested.emit()"
                            >
                                {{ 'aumico_abcp_notes_retry' | i18next }}
                            </ham-button>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loading && !error && isEmpty">
                    <td class="notes-ov__state-cell" [attr.colspan]="isTodo ? columns.length + 1 : columns.length">
                        <!-- „Nichts da" — KEIN Ausweg angeboten, es gibt keinen (AC12). -->
                        <p class="notes-ov__state" data-testid="notes-empty">
                            {{
                                (isTodo
                                    ? 'aumico_abcp_notes_overview_empty_todos'
                                    : 'aumico_abcp_notes_overview_empty_comments'
                                ) | i18next
                            }}
                        </p>
                    </td>
                </tr>

                <tr *ngIf="!loading && !error && isNoMatch">
                    <td class="notes-ov__state-cell" [attr.colspan]="isTodo ? columns.length + 1 : columns.length">
                        <!-- „Nichts gefunden" — anderer Satz, und MIT Ausweg. -->
                        <div class="notes-ov__state" data-testid="notes-no-match">
                            <p>{{ 'aumico_abcp_notes_overview_no_match' | i18next }}</p>
                            <button
                                type="button"
                                class="notes-ov__link"
                                data-testid="notes-no-match-reset"
                                (click)="filtersReset.emit()"
                            >
                                {{ 'aumico_abcp_notes_filters_reset' | i18next }}
                            </button>
                        </div>
                    </td>
                </tr>

                <tr
                    class="notes-ov__row"
                    data-testid="notes-row"
                    *ngFor="let row of rows; trackBy: trackById"
                    tabindex="0"
                    [attr.data-note-id]="row.id"
                    [attr.data-source]="row.source"
                    [attr.data-overdue]="isOverdue(row) ? '' : null"
                    [attr.data-done]="row.done ? '' : null"
                    [attr.data-recent]="isRecentlyChanged(row) ? '' : null"
                    (click)="onRowOpen(row)"
                    (keydown.enter)="onRowOpen(row)"
                    (keydown.space)="onRowOpen(row); $event.preventDefault()"
                >
                    <td class="notes-ov__td notes-ov__td--check" *ngIf="isTodo">
<!-- ⚠️ Ein KREIS, nicht ein Kasten: der Prototyp hat hier einen Radio-artigen Haken.
                             Ein eigener Knopf statt `input[type=checkbox]`, weil ein Kaestchen sich
                             nicht rund gestalten laesst, ohne sein Aussehen zu faelschen. -->
                        <button
                            type="button"
                            class="notes-ov__check"
                            data-testid="notes-row-done"
                            role="checkbox"
                            [attr.aria-checked]="!!row.done"
                            [attr.aria-label]="'aumico_abcp_notes_done_toggle' | i18next"
                            (click)="onDoneToggle(row, $event)"
                        >
                            <span aria-hidden="true">✓</span>
                        </button>
                    </td>

                    <td
                        class="notes-ov__td"
                        *ngFor="let column of columns"
                        [class.notes-ov__td--text]="column === 'text'"
                        [attr.data-testid]="'notes-cell-' + column"
                        [attr.data-column]="column"
                        [hamTooltip]="column === 'text' ? row.text : ''"
                        tooltipClass="abcp"
                        [tooltipOnlyWhenTruncated]="true"
                    >
                        <ng-container [ngSwitch]="column">
                            <!-- Der Text steht DIREKT in der Zelle: sie schneidet ab, nicht ein inneres Element. -->
                            <ng-container *ngSwitchCase="'text'">{{ row.text }}</ng-container>

                            <ng-container *ngSwitchCase="'tags'">
                                <div class="notes-ov__audience">
                                    <!-- `data-tag` traegt die Farbe (Reviewer gruen, Mandant
                                         orange) — im SCSS, damit der Contract an der Marke haengt und
                                         nicht an einer Klasse. -->
                                    <span
                                        class="notes-ov__tag"
                                        data-testid="notes-tag"
                                        *ngFor="let tag of row.tags"
                                        [attr.data-tag]="tag"
                                    >
                                        {{ 'aumico_abcp_notes_tag_' + tag | lowercase | i18next }}
                                    </span>
                                    <!-- Who the Pendenz is assigned to; the name in the tooltip. -->
                                    <ham-avatar
                                        *ngIf="row.assignee"
                                        data-testid="notes-assignee"
                                        [attr.data-assignee-id]="row.assignee.id"
                                        type="circle"
                                        size="s"
                                        variant="grey-border"
                                        [fullName]="row.assignee.name ?? '?'"
                                        [hamTooltip]="row.assignee.name ?? ''"
                                        tooltipClass="abcp"
                                    ></ham-avatar>
                                </div>
                            </ng-container>

                            <!-- Nummer obendrueber, Name gedaempft darunter — wie bei den
                                 Korrekturbuchungen. -->
                            <ng-container *ngSwitchCase="'account'">
                                <ng-container *ngIf="row.accountNumber; else noAccount">
                                    <code class="notes-ov__account-number">{{ row.accountNumber }}</code>
                                    <span
                                        class="notes-ov__account-name"
                                        [hamTooltip]="row.accountName"
                                        tooltipClass="abcp"
                                        [tooltipOnlyWhenTruncated]="true"
                                    >
                                        {{ row.accountName }}
                                    </span>
                                </ng-container>
                                <ng-template #noAccount>—</ng-template>
                            </ng-container>

                            <span *ngSwitchCase="'author'">
                                {{ row.author.name || ('aumico_abcp_notes_author_unknown' | i18next) }}
                            </span>

                            <span *ngSwitchCase="'created'">{{ row.createdLabel }}</span>

                            <!-- Ueberfaellig wird eingefaerbt UND benannt — Farbe allein ist keine Aussage. -->
                            <span *ngSwitchCase="'due'">
                                {{ row.dueLabel || '—' }}
                                <span class="notes-ov__overdue" *ngIf="isOverdue(row)">
                                    · {{ 'aumico_abcp_notes_overdue' | i18next }}
                                </span>
                            </span>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
